import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectEssSwitch } from 'shared/slice/essSwitchSlice';
import { selectTgsSwitch } from 'shared/slice/tgsSwitchSlice';
import { selectTesSwitch } from 'shared/slice/tesSwitchSlice';
import {
  handleReportStatus,
  selectReportStatus,
} from 'features/reportStatus/slice/reportStatusSlice';
import TitleContainer from 'shared/components/TitleContainer';
import EachLocationReportStatus from './EachLocationReportStatus';
import { useEffect } from 'react';
import { useGetAllSSRsQueries, useGetThermocouplesQueries } from 'shared/hooks';
import { selectUnits } from 'shared/slice/unitsSlice';

const ReportStatusMain = () => {


  const dispatch = useDispatch();
  const locations = useSelector(selectReportStatus);
  const { essSwitch,flatEssSwitch } = useSelector(selectEssSwitch);
  const { tgsSwitch } = useSelector(selectTgsSwitch);
  const { tesSwitch,flatTesSwitch } = useSelector(selectTesSwitch);
  const { isF } = useSelector(selectUnits);
  const { allLocations } = locations;





























  // report status shows the ssr report for every switch, not just faulted ones
  useGetAllSSRsQueries(flatEssSwitch, 'ESS', { faultedOnly: false });
  useGetAllSSRsQueries(flatTesSwitch, 'TES', { faultedOnly: false });
  useGetThermocouplesQueries(flatEssSwitch, 'ess');
  useGetThermocouplesQueries(flatTesSwitch, 'tes');

  useEffect(() => {
    dispatch(handleReportStatus({ essSwitch, tgsSwitch, tesSwitch, isF }));
  }, [essSwitch, tgsSwitch, tesSwitch]);

































  return (
    <Wrapper>
      <TitleContainer title='report status' />


      {allLocations.map((location, index) => (

        <EachLocationReportStatus
          key={index}
          mainIndex={index}
          location={location}
          allLocations={allLocations}
        />
      ))}
    </Wrapper>
  );
};

export default ReportStatusMain;

const Wrapper = styled.div`
  min-height: 674px !important;
  width: 1216px;
`;
